import React from 'react';
import './Modal.css';

/**
 * Reusable Modal Component
 * 
 * Usage:
 * <Modal show={show} onClose={handleClose} title="Modal Title">
 *   <p>Modal content</p>
 * </Modal>
 */
export default function Modal({ show, onClose, title, children, width = '500px', maxWidth }) {
  if (!show) return null;

  const modalStyle = { width };
  if (maxWidth) {
    modalStyle.maxWidth = maxWidth;
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-content"
        style={modalStyle}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div className="modal-header">
            <h2 className="modal-title">{title}</h2>
            <button className="modal-close" onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>
        )}
        <div className="modal-body">{children}</div>
      </div>
    </div>
  );
}

